module.exports = __webpack_public_path__ + "static/media/professional-icon.0751695e.svg";